export default __webpack_public_path__ + "static/media/icon-accordance-created.2a595fa0.svg";